<template>
  <v-container class="pt-0 pr-0">
    <v-toolbar flat>
      <v-toolbar-title />
      <v-spacer />

      <individual-account-update-dialog
        v-if="account.business_type === 'individual'"
        :account="account"
        @action="onEdit($event)"
      >
        <template #activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            v-on="on"
          >
            <v-icon left>
              edit
            </v-icon>
            Update Individual Info
          </v-btn>
        </template>

      </individual-account-update-dialog>

      <company-account-update-dialog
        v-if="account.business_type === 'company'"
        :account="account"
        @action="onEdit($event)"
      >
        <template #activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            v-on="on"
          >
            <v-icon left>
              edit
            </v-icon>
            Update Business Info
          </v-btn>
        </template>
      </company-account-update-dialog>
    </v-toolbar>

    <v-divider class="my-3" />
    <v-row>
      <v-col
        v-if="account.business_type === 'individual'"
        cols="12"
        xs="12"
        md="10"
      >
        <info-list
          :list="individualInfo()"
        />
      </v-col>
      <v-col
        v-if="account.business_type === 'company'"
        cols="12"
        xs="12"
        md="10"
      >
        <info-list
          :list="companyInfo"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { get } from 'lodash'
import InfoList from '@/components/Common/InfoList.vue'
import { formatDate } from "../../services/util.service"
import CompanyAccountUpdateDialog from "./CompanyAccountUpdateDialog"
import IndividualAccountUpdateDialog from "./IndividualAccountUpdateDialog"

export default {
  components: {
    IndividualAccountUpdateDialog,
    CompanyAccountUpdateDialog,
    InfoList
  },
  props: {
    account: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      model: {}
    }
  },
  computed: {
    companyInfo() {
      return [
        {
          label: 'Legal Name',
          value: get(this.model, 'company.name', '')
        },
        {
          label: 'Phone',
          value: get(this.model, 'company.phone')
        },
        // {
        //   label: 'Email',
        //   value: get(this.model, 'email')
        // },
        {
          label: 'Address',
          value: [
            get(this.model, 'company.address.line1'),
            get(this.model, 'company.address.line2'),
            [
              get(this.model, 'company.address.city'),
              get(this.model, 'company.address.state'),
              get(this.model, 'company.address.postal_code'),
            ].filter(Boolean).join(', '),
            get(this.model, 'company.address.country'),
          ]
        },
        {
          label: 'Public Name',
          value: get(this.model, 'business_profile.name')
        },
        {
          label: 'Public Description',
          value: get(this.model, 'business_profile.product_description')
        },
        {
          label: 'Public Website',
          value: get(this.model, 'business_profile.url')
        },
        {
          label: 'Social Media',
          value: [
            get(this.model, 'metadata.social_facebook'),
            get(this.model, 'metadata.social_twitter'),
            get(this.model, 'metadata.social_instagram'),
            get(this.model, 'metadata.social_youtube')
          ]
        },
        {
          label: 'Support Email',
          value: get(this.model, 'business_profile.support_email', '')
        },
        {
          label: 'Support Phone',
          value: get(this.model, 'business_profile.support_phone', '')
        },
        {
          label: 'Support Website',
          value: get(this.model, 'business_profile.support_url', '')
        },
        {
          label: 'Tax ID',
          value: get(this.model, 'company.tax_id_provided') ? 'Provided' : 'Required'
        },
        {
          label: 'Services Agreement',
          value: get(this.model, 'tos_acceptance.date') ? `Agreed on ${formatDate(get(this.model, 'tos_acceptance.date'))}` : 'Required'
        },
      ]
    },
  },
  mounted() {
    this.model = { ...this.account }
  },
  methods: {
    onEdit(account) {
      this.model = { ...account }
    },
    individualInfo() {
      return [
        {
          label: 'Legal Name',
          value: `${get(this.model, 'individual.first_name')}  ${get(this.model, 'individual.last_name')}`
        },
        {
          label: 'Phone',
          value: get(this.model, 'individual.phone')
        },
        {
          label: 'Email',
          value: get(this.model, 'individual.email')
        },
        {
          label: 'Address',
          value: [
            get(this.model, 'individual.address.line1'),
            get(this.model, 'individual.address.line2'),
            [
              get(this.model, 'individual.address.city'),
              get(this.model, 'individual.address.state'),
              get(this.model, 'individual.address.postal_code'),
            ].filter(Boolean).join(', '),
            get(this.model, 'individual.address.country'),
          ]
        },
        {
          label: 'Public Name',
          value: get(this.model, 'business_profile.name')
        },
        {
          label: 'Public Description',
          value: get(this.model, 'business_profile.product_description')
        },
        {
          label: 'Public Website',
          value: get(this.model, 'business_profile.url')
        },
        {
          label: 'Social Media',
          value: [
            get(this.model, 'metadata.social_facebook'),
            get(this.model, 'metadata.social_twitter'),
            get(this.model, 'metadata.social_instagram'),
            get(this.model, 'metadata.social_youtube')
          ]
        },
        {
          label: 'Support Email',
          value: get(this.model, 'business_profile.support_email', '')
        },
        {
          label: 'Support Phone',
          value: get(this.model, 'business_profile.support_phone', '')
        },
        {
          label: 'Support Website',
          value: get(this.model, 'business_profile.support_url', '')
        },

        {
          label: 'ID Number',
          value: get(this.model, 'individual.id_number_provided') ? 'Provided' : 'Required'
        },
        {
          label: 'Services Agreement',
          value: get(this.model, 'tos_acceptance.date') ? `Agreed on ${formatDate(get(this.model, 'tos_acceptance.date'))}` : 'Required'
        },
      ]
    }
  }
}
</script>
